/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Modal, Input, Button } from 'semantic-ui-react'

const AddMoreSerailNumber = ({
  ...props
}) => {
  const [newSerialNoModal, setNewSerialNoModal] = useState('');

  useEffect(() => {
  }, [])

  const setInputValue = (e) => {
    setNewSerialNoModal(e.target.value)
  }

  const saveModal = (e) => {
    e.stopPropagation();
    /*  setNewSerialNoModal(e.target.value) */
    props.addSerialNoToList(newSerialNoModal);
  }

  const closeModal = (e) => {
    /*  setNewSerialNoModal(e.target.value) */
    props.setmodalOpen(e)
  }

  return (
    <>
      <Modal onClose={(e) => props.setmodalOpen(e)} open={props.modalOpen} size="tiny">
        <Modal.Header>New Serial No</Modal.Header>
        <Modal.Content>
          <div>
            <label>
              New Serial No
              <Input className='ml-2' type='text' onChange={setInputValue} />
            </label>

            <div className='display-flex-space-even mt-4'>
              <Button primary onClick={(e) => saveModal(e)}>Save</Button>
              <Button secondary onClick={(e) => closeModal(e)}>Cancel</Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </>
  )
}

export default AddMoreSerailNumber